import {
  useEffect,
  useState,
  type ComponentType,
} from "react";
import { useNavigate } from "react-router-dom";

import { getUserProfiles } from "service1/dashboardService";

import type { Account }
from "../types/dashboard.types";
type RemoteComponent =
  ComponentType<Record<string, unknown>>;


type UseDashboardHomeReturn = {
  accounts: Account[];
  handleSelect: (acc: Account) => void;
Button: RemoteComponent | null;  loading: boolean;
  navigate: ReturnType<typeof useNavigate>;
};

export default function useDashboardHome():
UseDashboardHomeReturn {

  const [accounts, setAccounts] =
    useState<Account[]>([]);

  const [Button, setButton] =
  useState<RemoteComponent | null>(
    null
  );
const authToken =
  sessionStorage.getItem("AUTH_TOKEN") || "";
  const token = sessionStorage.getItem("token");

  const navigate = useNavigate();

  useEffect(() => {
    import("remote_app/Button").then((mod) => {
setButton(
  () => mod.default as RemoteComponent
);    });
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getUserProfiles(
          token!,
          authToken
        );

        if (Number(data.statusType) === 1) {
          const list = data?.users || [];

          setAccounts(list);
        }
      } catch (err) {
        console.error(err);
      }
    };

    if (token) fetchUsers();
  }, [token, authToken]);

  const handleSelect = (acc: Account) => {
    console.log("Selected account:", acc);
  };

  return {
    accounts,
    handleSelect,
    Button,
    loading: !Button,
    navigate,
  };
}